// Phase definitions for K.O. CO+RE Active Jobs.
// Order matches the user-specified spec for the visual phase tracker.
export const JOB_PHASES = [
  { index: 0, key: 'lead', label: 'Lead' },
  { index: 1, key: 'demo', label: 'Demo' },
  { index: 2, key: 'framing', label: 'Framing' },
  { index: 3, key: 'rough-ins', label: 'Rough-ins' },
  { index: 4, key: 'drywall', label: 'Drywall' },
  { index: 5, key: 'paint', label: 'Paint' },
  { index: 6, key: 'trim', label: 'Trim' },
  { index: 7, key: 'punch-list', label: 'Punch list' },
  { index: 8, key: 'complete', label: 'Complete' },
];

export const PHASE_MAX_INDEX = JOB_PHASES.length - 1; // 8

export const getPhase = (index) => {
  const i = Math.max(0, Math.min(PHASE_MAX_INDEX, Number(index) || 0));
  return JOB_PHASES[i];
};

export const getPhaseLabel = (index) => getPhase(index).label;

export const getPhaseProgressPct = (index) => {
  const i = Math.max(0, Math.min(PHASE_MAX_INDEX, Number(index) || 0));
  return Math.round((i / PHASE_MAX_INDEX) * 100);
};

export const isPhaseComplete = (index) =>
  Number(index) >= PHASE_MAX_INDEX;

export const NOTE_TYPES = [
  { key: 'general', label: 'General' },
  { key: 'milestone', label: 'Milestone' },
  { key: 'issue', label: 'Issue' },
  { key: 'client', label: 'Client' },
  // Legacy seed data uses 'field' \u2014 we keep it as a hidden alias.
  { key: 'field', label: 'Field' },
];

export const noteTypeLabel = (type) => {
  const found = NOTE_TYPES.find((n) => n.key === type);
  if (found) return found.label;
  if (!type) return 'General';
  return String(type).replace(/\b\w/g, (c) => c.toUpperCase());
};

export const noteTypeBadgeClass = (type) => {
  switch (type) {
    case 'milestone':
      return 'bg-[hsl(var(--primary))]/12 text-[hsl(var(--primary))] border-[hsl(var(--primary))]/30';
    case 'issue':
      return 'bg-[hsl(var(--destructive))]/12 text-[hsl(var(--destructive))] border-[hsl(var(--destructive))]/30';
    case 'client':
      return 'bg-[hsl(var(--info))]/12 text-[hsl(var(--info))] border-[hsl(var(--info))]/30';
    case 'field':
    case 'general':
    default:
      return 'bg-[hsl(var(--muted))] text-foreground border-border';
  }
};

export const formatNoteDate = (dateInput) => {
  if (!dateInput) return '';
  // Accept either a Date or a contractor string like 'Apr 7'.
  if (dateInput instanceof Date) {
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
    }).format(dateInput);
  }
  return String(dateInput);
};

/**
 * Use today\u2019s date in the same compact format used by seeded notes
 * (e.g. 'Apr 7') so visual ordering stays consistent.
 */
export const todayLabel = () =>
  new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
  }).format(new Date());
